import { useMediaQuery } from 'react-responsive';

export const Responsive = ({ desktop, mobile }) => {
    const isDesktop = useMediaQuery({ query: "(orientation: landscape) and (min-height: 600px)"});
    return isDesktop ? desktop : mobile;
};